import { AvatarProps, Avatar as MuiAvatar, SvgIconTypeMap, useTheme } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { FC } from 'react';

type Props = AvatarProps & {
  text?: string;
  size?: 'md' | 'lg';
  color?: 'random' | 'grey';
  icon?: OverridableComponent<SvgIconTypeMap<object>>;
};

const Avatar: FC<Props> = ({ text, color, size = 'md', icon: Icon, ...rest }) => {
  const theme = useTheme();

  const bgColors = [
    theme.palette.primary.main,
    theme.palette.secondary.main,
    theme.palette.error.main,
    theme.palette.warning.main,
    theme.palette.info.main,
    theme.palette.success.main,
  ];

  const sizes = {
    md: 24,
    lg: 32,
  };

  const fontSizes = {
    md: theme.fontSizes.sm,
    lg: undefined,
  };

  const textIndex = text?.length ? text.charCodeAt(0) : 1;
  const bgColor = color === 'random' ? bgColors[textIndex % 6] : undefined;

  return (
    <MuiAvatar
      sx={{
        backgroundColor: bgColor,
        width: sizes[size],
        height: sizes[size],
        fontSize: fontSizes[size],
      }}
      {...rest}
    >
      {text?.length ? text.charAt(0).toUpperCase() : Icon ? <Icon /> : null}
    </MuiAvatar>
  );
};

export default Avatar;
